import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { UploadIcon } from "lucide-react";
import React, { useEffect } from "react";
import { db as storage } from "../../utils/firebaseConfig";
import { Button, FileButton, Progress, Text } from "@mantine/core";
import { notifications } from "@mantine/notifications";

const UserUploadDataFirebase = ({ type, onChange, label }) => {
  const [date, setDate] = React.useState("0");
  const [uploading, setUploading] = React.useState(false);
  const [uploadProgress, setUploadProgress] = React.useState(0);
  const [fileName, setFileName] = React.useState("");

  useEffect(() => {
    setDate(Date.now());
  }, []);

  const acceptMap = {
    srt: ".srt",
    photos: "image/*",
    videos: "video/*",
  };

  const handleFile = (file) => {
    if (!file) return;
    setFileName(file.name);
    setUploading(true);

    const uploadTask = uploadBytesResumable(
      ref(storage, `${type}/${date}${file.name}`),
      file
    );

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(progress);
      },
      (error) => {
        notifications.show({ message: error.message, color: "red" });
        setUploading(false);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          onChange && onChange(downloadURL);
          setUploading(false);
          setUploadProgress(0);
        });
      }
    );
  };

  return (
    <div>
      <FileButton onChange={handleFile} accept={acceptMap[type] || "*"}>
        {(props) => (
          <Button
            {...props}
            leftSection={<UploadIcon size={16} />}
            variant="default"
            loading={uploading}
          >
            Upload {label}
          </Button>
        )}
      </FileButton>
      {fileName && (
        <Text size="xs" c="dimmed" mt={4}>
          {fileName}
        </Text>
      )}
      {uploading && uploadProgress > 0 && uploadProgress < 100 && (
        <Progress value={uploadProgress} mt={8} size="sm" />
      )}
    </div>
  );
};

export default UserUploadDataFirebase;
